<template>
  <section class="event-search">
    <span class="label">Search By</span>

    <AppDropdown
      class="event-dropdown"
      :trigger-text="searchDropdownTriggerText"
      :disabled="metadata.length === 1"
    >
      <template
        v-for="(option, index) in metadata"
        :key="index"
      >
        <AppDropdownItem @click="handleNewSearchBy(option)">
          {{ metadataLabel(option) }}
        </AppDropdownItem>
      </template>
    </AppDropdown>

    <input
      v-model="searchParams.search"
      type="text"
      :class="!searchParams.searchBy || searchParams.searchBy === 'bibNumber' ? 'font-mono text-2xl xs:text-base sm:text-2xl' : 'text-base xs:text-sm sm:text-base'"
      :placeholder="searchInputPlaceholderText"
      @keyup.enter="$emit('handleSearch')"
    >

    <AppButton
      class="btn-solid btn-secondary btn-event-search"
      :disabled="!searchParams.search"
      @click="() => { protectedCategory = null; searchParams.category = null; $emit('handleSearch') }"
    >
      Search
    </AppButton>
  </section>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import {
  AppButton,
  AppDropdown,
  AppDropdownItem,
} from '@/components/app';

defineEmits(['handleSearch']);

const props = defineProps({
  metadata: {
    type: Array,
    default: () => null,
  },
});

const searchParams = defineModel('searchParams');
const protectedCategory = defineModel('protectedCategory');

const searchDropdownTriggerText = ref('');

const handleNewSearchBy = (option) => {
  searchParams.value.searchBy = option;
  searchParams.value.search = null;
  searchDropdownTriggerText.value = metadataLabel(option);
};

const metadataLabel = (option) => {
  const options = {
    'bibNumber': 'Bib Number',
    'athleteName': 'Athlete Name',
    'club': 'Club',
    'team': 'Team',
  };

  return options[option] || '';
};

const searchInputPlaceholderText = computed(() => {
  const options = {
    'bibNumber': '0000',
    'athleteName': 'Athlete Name',
    'club': 'Club Name',
    'team': 'Team Name',
  };

  return options[searchParams.value.searchBy] || '';
});

onMounted(() => {
  searchDropdownTriggerText.value = metadataLabel(props.metadata[0]);
});

</script>
